import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';

import { includesConditionOptions } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import useCaseCloseReason from 'hooks/useCaseCloseReason';

const CaseClosureReasonFilter = ({ index }) => {
  const { caseCloseReasonList, isCloseReasonLoading } = useCaseCloseReason({ isLead: false });
  const {
    formState: { errors },
    control,
  } = useFormContext();

  return (
    <>
      <div className="me-2 filterbar-condition">
        <Controller
          name={`filters.${index}.condition`}
          control={control}
          rules={{ required: 'Condition is required' }}
          render={({ field }) => (
            <Dropdown
              options={includesConditionOptions}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              placeholder="Select Condition"
              className="w-100"
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.condition`} errors={errors} />
      </div>
      <div className="me-2 filterbar-value">
        <Controller
          name={`filters.${index}.value`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <MultiSelect
              options={caseCloseReasonList}
              value={field.value?.closure_reason || []}
              onChange={(e) => field.onChange({ closure_reason: e.value })}
              placeholder="Select Value"
              isFilter={true}
              className="input-shadow w-100"
              display="chip"
              dropdownIcon={isCloseReasonLoading ? 'pi pi-spin pi-spinner' : undefined}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.value`} errors={errors} />
      </div>
    </>
  );
};

export default CaseClosureReasonFilter;
